module.exports = __webpack_public_path__ + "img/pizza_five_eighths_96px2_sabor.fw.a68f593e.png";